import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-4b21aa0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-wrapper d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = ["aria-labelledby"]
const _hoisted_5 = ["href"]

import { ref, onMounted, nextTick } from 'vue';
  import { Menu } from '@/types/menu';

  interface IProps {
    menus: Menu[]
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    menus: null
  },
  setup(__props: any) {

const props = __props as {
    menus: Menu[]
  }

  
  const currentDropdownId = ref('');

  const init = async () => {
    await nextTick();
    props.menus.forEach(item => {
      const el = document.getElementById(item.id);
      if (el) {
        el.addEventListener('show.bs.dropdown', () => {
          currentDropdownId.value = item.id;
        });
        el.addEventListener('hide.bs.dropdown', () => {
          if (item.id === currentDropdownId.value) {
            currentDropdownId.value = '';
          }
        });
      }
    });
  };

  onMounted(init);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menus, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.name,
        class: "menu-item"
      }, [
        (item.children && item.children.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                id: item.id,
                class: "dropdown-box d-flex align-items-center",
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false"
              }, [
                _createElementVNode("span", null, _toDisplayString(item.name), 1),
                _createElementVNode("img", {
                  src: _imports_0,
                  class: _normalizeClass(["arrow", { rotate: item.id === currentDropdownId.value }])
                }, null, 2)
              ], 8, _hoisted_3),
              _createElementVNode("ul", {
                class: "dropdown-menu",
                "aria-labelledby": item.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (menu) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: menu.id,
                    class: "dropdown-item"
                  }, [
                    _createVNode(_component_router_link, {
                      to: menu.to,
                      class: "router-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menu.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ], 8, _hoisted_4)
            ]))
          : (item.external)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: item.external,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "router-link"
              }, _toDisplayString(item.name), 9, _hoisted_5))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: item.to,
                class: "router-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
      ]))
    }), 128))
  ]))
}
}

})